// Constants.
// -----------------------------------------------------------------------------
// Default values.
export const BUTTON_DEFAULT_DISABLED = false;
export const BUTTON_DEFAULT_ICON_LOADING_TITLE = 'start-icon-loading';
export const BUTTON_DEFAULT_LOADING = false;
export const BUTTON_DEFAULT_MODE = 'light';
export const BUTTON_DEFAULT_SCHEME = 'neutral';
export const BUTTON_DEFAULT_SIZE = 's';
export const BUTTON_DEFAULT_VARIANT = 'hard';
// Mapping
export const BUTTON_ICON_SIZES = {
    s: '2xl',
    xs: 'l',
    '2xs': 'l'
};
export const BUTTON_TEXT_PROPS = {
    s: {
        size: 's',
        bold: true,
        uppercase: true
    },
    xs: {
        size: 'xs',
        bold: true,
        uppercase: true
    },
    '2xs': {
        size: 'xs',
        bold: true,
        uppercase: true
    }
};
export const BUTTON_PADDING_SIZES = {
    s: {
        horizontal: 'l',
        vertical: 'l'
    },
    xs: {
        horizontal: 'm',
        vertical: 'm'
    },
    '2xs': {
        horizontal: 's',
        vertical: 's'
    }
};
//# sourceMappingURL=Button.constants.js.map